import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { BpError } from '../Icons';

export type ControllerTextFieldProps = Omit<TextFieldProps, 'select'> & {
  errorText?: string;
  readOnlyDisabled?: boolean;
  readOnly?: boolean;
};

export const ControllerTextField = function (props: ControllerTextFieldProps) {
  const {
    readOnly,
    readOnlyDisabled,
    errorText,
    helperText,
    inputProps,
    InputProps,
    InputLabelProps,
    ...textFieldProps
  } = props;

  return (
    <MuiTextField
      helperText={props.error && errorText ? errorText : helperText}
      InputLabelProps={{
        className: readOnlyDisabled ? 'Mui-disabled' : undefined,
        ...InputLabelProps,
      }}
      inputProps={{
        // classes added here are merged into existing MUI classes
        className: readOnlyDisabled ? 'Mui-disabled' : undefined,
        ...inputProps,
      }}
      InputProps={{
        readOnly: readOnly || readOnlyDisabled,
        className: readOnlyDisabled ? 'Mui-disabled' : undefined,
        tabIndex: readOnlyDisabled ? -1 : undefined,
        endAdornment: props.error && <BpError color='error' />,
        ...InputProps,
      }}
      {...textFieldProps}
    />
  );
};

ControllerTextField.displayName = 'ControllerTextField';
